import { type IBusiness, showToast } from 'BreetHelpers';
import { clearCredentials, logUserIn, selectLastVisited, setBusiness, useAppDispatch, useAppSelector } from 'BreetRedux';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { inactivityStorage } from '@/lib';

export const useLoginSuccess = () => {
	const navigate = useNavigate();

	const dispatch = useAppDispatch();

	const lastVisited = useAppSelector(selectLastVisited);

	const onLoginSuccess = useCallback(
		(business?: IBusiness) => {
			dispatch(clearCredentials());
			dispatch(logUserIn());
			dispatch(setBusiness(business ?? null));
			inactivityStorage.update('lastActivity', Date.now());
			navigate(lastVisited ?? '/home')?.catch(console.error);
			showToast('success', 'Login successful. Welcome back! 🎉');
		},
		[dispatch, lastVisited, navigate]
	);

	return {
		onLoginSuccess,
	};
};
